module.exports = __webpack_public_path__ + "img/v2_2.81e18635.png";